<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>业务附件</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.id" placeholder="请输入ID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.bill_number" placeholder="请输入单号" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="demander_rid"
                    model_name="请输入客户搜索"
                    request_uri="searchAccounts"
                    default_option_key="demander_option"
                    :default_option="queryParams['demander_option']"
                    @onDropChange="onDropChange"
                    ref="demander_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="supplier_rid"
                    model_name="请输入组织搜索"
                    request_uri="searchAccounts"
                    default_option_key="supplier_option"
                    :default_option="queryParams['supplier_option']"
                    @onDropChange="onDropChange"
                    ref="supplier_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.description" placeholder="请输入描述" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="is_exception"
                    model_name="是否异常"
                    :model_value_default="queryParams['is_exception']"
                    select_value="value"
                    request_uri="yesOrNo"
                    @onDropChange="onDropChange"
                    ref="is_exception_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <el-button size="small" plain icon="el-icon-bottom" @click="download()" :loading="down_loading">下载附件</el-button>

                    <!-- <crm-upload obj="transaction_attachment" :queryParams="queryParams"></crm-upload> -->
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >下载附件耗时较久（平均1s/张），请耐心等待。期间请勿关闭或刷新页面。单次下载限制200张图片，请增加筛选条件控制图片数</span
                    >
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="transaction_attachment"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['bill_number'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px">{{
                                    scope.row[item.prop]
                                }}</el-link>
                            </div>
                            <div v-if="in_array(item.prop, ['path'])">
                                <el-link
                                    v-for="(path_item, path_index) in scope.row[item.prop]"
                                    :key="path_index"
                                    type="primary"
                                    @click="toQiniuPrivateShow(scope.row['domain'] + path_item)"
                                    style="font-size: 11px"
                                >
                                    {{ getSuffix(path_item, '/', false) }} &nbsp;
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete, qiniuPrivateShow, getSuffix } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'transactionAttachmentComponent',
    data() {
        return {
            draggable: {
                data_name: 'transaction_attachment'
            },
            is_show_help: false,
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        getSuffix,
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['bill_number']) && row.id) {
                this.$router.push({
                    path: '/transactionAttachmentDetail',
                    query: {
                        id: row.id
                    }
                });
            }
        },
        toQiniuPrivateShow(path) {
            qiniuPrivateShow(path, this);
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('transaction_attachment_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('transaction_attachment_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('transaction_attachment', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).transaction_attachment;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'transactionAttachmentLists');
        },
        download() {
            this.down_loading = true;
            this.$api['transactionAttachmentDownload'](this.queryParams)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: '下载成功！',
                            type: 'success'
                        });
                    }
                    this.down_loading = false;
                })
                .catch((error) => {
                    this.down_loading = false;
                });
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //编辑
        update(id) {
            this.$router.push({
                path: 'transactionAttachmentEdit',
                query: {
                    type: 'update',
                    id: id
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'transactionAttachmentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(id) {
            this.$router.push({
                path: 'transactionAttachmentEdit',
                query: {
                    type: 'copy',
                    id: id
                }
            });
        },
        reset() {
            this.$refs.is_exception_ref.reset();
            this.$refs.supplier_rid_ref.reset();
            this.$refs.demander_rid_ref.reset();

            this.initQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
            }

            this.getList();
        },

        //删除
        del(row) {
            onDelete(row.id, this, 'transactionAttachmentDelete', row.bill_number);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>